import WeatherSun from './src/weather-sun-combined';
export default WeatherSun;